// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    autoTitle: {
        id: 'hotwater.boost.auto-title',
        defaultMessage: 'Boost'
    },
    heatTitle: {
        id: 'hotwater.boost.heat-title',
        defaultMessage: 'Boost'
    },
    coolTitle: {
        id: 'hotwater.boost.cool-title',
        defaultMessage: 'Boost'
    },
    thirtyMinutes: {
        id: 'hotwater.boost.thirty-minutes',
        defaultMessage: '30 minutes'
    },
    oneHour: {
        id: 'hotwater.boost.one-hour',
        defaultMessage: '01 hour'
    },
    twoHours: {
        id: 'hotwater.boost.two-hours',
        defaultMessage: '02 hours'
    },
    threeHours: {
        id: 'hotwater.boost.three-hours',
        defaultMessage: '03 hours'
    },
    fourHours: {
        id: 'hotwater.boost.four-hours',
        defaultMessage: '04 hours'
    },
    fiveHours: {
        id: 'hotwater.boost.five-hours',
        defaultMessage: '05 hours'
    },
    sixHours: {
        id: 'hotwater.boost.six-hours',
        defaultMessage: '06 hours'
    }
});



// WEBPACK FOOTER //
// ./src/core/i18n/components/widgets/boost/intl.js